/* OMR-inspired landing — countdown + phase-ladder logic.
   Vanilla JS, no dependencies. Loaded with defer by the
   omr-* sections; guarded so multiple includes are safe. */
(function () {
  'use strict';

  if (window.__omrLandingInit) return;
  window.__omrLandingInit = true;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* Live countdowns: [data-omr-countdown][data-deadline] */
  function initCountdowns() {
    var nodes = document.querySelectorAll('[data-omr-countdown]');
    if (!nodes.length) return;

    var timers = [];
    nodes.forEach(function (node) {
      var deadline = new Date(node.getAttribute('data-deadline')).getTime();
      if (isNaN(deadline)) {
        node.hidden = true;
        return;
      }
      var els = {
        days: node.querySelector('[data-days]'),
        hours: node.querySelector('[data-hours]'),
        minutes: node.querySelector('[data-minutes]'),
        seconds: node.querySelector('[data-seconds]')
      };
      timers.push({ node: node, deadline: deadline, els: els });
    });

    if (!timers.length) return;

    function tick() {
      var now = Date.now();
      timers.forEach(function (t) {
        var diff = t.deadline - now;
        if (diff <= 0) {
          diff = 0;
          var expired = t.node.getAttribute('data-expired-text');
          var bar = t.node.closest('[data-omr-phasebar]');
          if (expired && bar) {
            var note = bar.querySelector('[data-omr-phase-note]');
            if (note) note.textContent = expired;
          }
        }
        var s = Math.floor(diff / 1000);
        if (t.els.days) t.els.days.textContent = pad(Math.floor(s / 86400));
        if (t.els.hours) t.els.hours.textContent = pad(Math.floor((s % 86400) / 3600));
        if (t.els.minutes) t.els.minutes.textContent = pad(Math.floor((s % 3600) / 60));
        if (t.els.seconds) t.els.seconds.textContent = pad(s % 60);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* Phase ladder: mark each .omr-phase as past / current / future
     from its data-phase-end (ISO date). The first phase whose end
     is still in the future is the current one. */
  function initPhaseLadders() {
    document.querySelectorAll('[data-omr-phases]').forEach(function (ladder) {
      var phases = Array.prototype.slice.call(ladder.querySelectorAll('.omr-phase'));
      var now = Date.now();
      var currentFound = false;

      phases.forEach(function (phase) {
        var end = new Date(phase.getAttribute('data-phase-end')).getTime();
        phase.classList.remove('is-past', 'is-current', 'is-future');
        if (!isNaN(end) && end <= now) {
          phase.classList.add('is-past');
        } else if (!currentFound) {
          phase.classList.add('is-current');
          currentFound = true;
        } else {
          phase.classList.add('is-future');
        }
      });

      // Centre the current phase inside the ladder. Set scrollLeft directly
      // rather than using scrollIntoView, which would also scroll the page.
      var current = ladder.querySelector('.omr-phase.is-current');
      if (current && ladder.scrollWidth > ladder.clientWidth) {
        ladder.scrollLeft = Math.max(
          0,
          current.offsetLeft - (ladder.clientWidth - current.offsetWidth) / 2
        );
      }
    });
  }


  /* Hero video play/pause control */
  function initVideoToggles() {
    document.querySelectorAll('[data-omr-video-toggle]').forEach(function (btn) {
      var media = btn.closest('[data-omr-hero-media]');
      var video = media ? media.querySelector('video') : null;
      if (!video) {
        btn.hidden = true;
        return;
      }

      function sync() {
        var paused = video.paused;
        btn.classList.toggle('is-paused', paused);
        btn.setAttribute(
          'aria-label',
          paused ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause')
        );
      }

      btn.addEventListener('click', function () {
        if (video.paused) {
          var played = video.play();
          if (played && typeof played.catch === 'function') played.catch(function () {});
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });
  }

  function init() {
    initCountdowns();
    initVideoToggles();
    initPhaseLadders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
